import { PlusIcon } from '@phosphor-icons/react'

import { Button, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ScenarioSection = ({ title, emptyDescription, addLabel, isEmpty, onAdd, children }) => {
  return (
    <Styles.Container>
      <Text type="titleS">{title}</Text>
      {isEmpty && <Styles.Description type="bodySRegular">{emptyDescription}</Styles.Description>}
      {!isEmpty && <Styles.Cards>{children}</Styles.Cards>}
      <Button variant="text" size="s" onClick={onAdd}>
        <PlusIcon size={20} />
        {addLabel}
      </Button>
    </Styles.Container>
  )
}

export default ScenarioSection
